import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { find, propEq, filter } from 'ramda';
import AccountContentWrapper from '../../common/AccountContentWrapper/AccountContentWrapper';
import OrderFeedback from './OrderFeedback';
import FeedbackTyp from './FeedbackTyp';
import { api } from '../../../../api/requestor';
import { setTitle } from '../../../../helpers/title-helper';
import { changeNewAnswers, getDefaultAnswers, getGroupSegmentQuestions, getDifference, getQuestionsIds } from './helpers';
import { getTrueOrder, getTrueFeedback, getFalseAnswers } from '../../../../helpers/account-helper';
import { isDefaultAccountSpa, orderParams } from '../../helpers';
/**
 * Оставить отзыв
 */
class OrderFeedbackContainer extends PureComponent {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        orderId: PropTypes.string.isRequired,
        orderToken: PropTypes.string
      })
    }),
    routes: PropTypes.array,
    returnPath: PropTypes.string
  };
  state = {
    groups: [],
    questions: [],
    answers: [],
    isFormChanged: false,
    errorsIds: [],
    isFeedbackCompleted: false,
    isFeedbackButtonLoading: false,
    scrollTo: null
  };
  UNSAFE_componentWillMount() {
    setTitle(I18n.t('components.OrderFeedback.title'));
    api.get.account.order(this.props.match.params.orderId, orderParams).then(({
      data
    }) => {
      const accountProps = getTrueOrder(data);
      this.setFeedbackData(accountProps);
    });
  }
  componentDidMount() {
    import(/* webpackMode: "eager" */'../../../../helpers/animations').then(animations => {
      this.setState({
        scrollTo: animations.scrollTo
      });
    });
  }
  onValidate = () => {
    const {
      answers,
      requiredQuestionsIds
    } = this.state;
    const errorsIds = getDifference({
      arrA: requiredQuestionsIds,
      arrB: getQuestionsIds(answers)
    });
    this.setState({
      errorsIds
    }, this.scrollToInvalidField(errorsIds[0]));
    const hasNoErrors = !errorsIds.length;
    if (hasNoErrors) {
      this.submitHandler();
    }
  };
  setFeedbackData(accountProps) {
    const {
      segments
    } = accountProps;
    api.get.account.feedback(this.props.match.params.orderId, orderParams).then(({
      data
    }) => {
      const trueData = getTrueFeedback(data);
      const {
        groups,
        questions
      } = trueData;
      const findSegment = segmentId => find(propEq('segmentId', segmentId));
      const newGroups = groups.map(({
        segmentId,
        questionIds,
        ...rest
      }) => {
        const segment = findSegment(segmentId)(segments);
        const groupQuestions = filter(question => questionIds.includes(question.id))(questions);
        const groupSegmentQuestions = getGroupSegmentQuestions(groupQuestions, segment);
        return {
          ...rest,
          segment,
          questions: groupSegmentQuestions,
          changeHandler: this.changeHandler
        };
      });
      this.setState({
        ...trueData,
        groups: newGroups,
        isFeedbackCompleted: accountProps.isFeedbackCompleted,
        answers: getDefaultAnswers(newGroups)
      });
    });
  }
  /**
  * Изменение значения выбранного ответа
  */
  changeHandler = params => {
    const {
      answers
    } = this.state;
    const newAnswers = changeNewAnswers(answers, params);
    this.setState({
      answers: newAnswers,
      errorsIds: [],
      isFormChanged: true
    });
  };
  /**
  * Нажатие на кнопку отправить
  */
  submitHandler = () => {
    const {
      routes,
      match: {
        params: {
          orderId
        }
      }
    } = this.props;
    const {
      answers
    } = this.state;
    this.setState({
      isLoading: true
    });
    api.post.account.feedback({
      orderId,
      params: {
        answers: getFalseAnswers(answers),
        ...orderParams
      }
    }).then(({
      errors
    }) => {
      if (errors) {
        this.setState({
          isLoading: false
        });
        return null;
      }
      if (isDefaultAccountSpa) {
        // Перенаправляем человека на страницу заказов
        window.location.replace(routes.index.to);
      } else {
        this.setState({
          isFeedbackCompleted: true
        });
      }
      return true;
    });
  };
  redirectToRoot = () => {
    this.setState({
      isFeedbackButtonLoading: true
    }, () => {
      window.location.replace('/');
    });
  };
  scrollToInvalidField = id => {
    const {
      scrollTo
    } = this.state;
    if (scrollTo) {
      scrollTo({
        target: document.getElementById(id),
        offset: 60
      });
    }
  };
  render() {
    const {
      routes,
      returnPath
    } = this.props;
    const {
      groups,
      questions,
      isLoading,
      segments,
      isFeedbackCompleted,
      isFeedbackButtonLoading,
      isFormChanged,
      errorsIds
    } = this.state;
    const hasErrors = !!errorsIds.length;
    const isDisabled = hasErrors || isFormChanged && hasErrors;
    if (isDefaultAccountSpa) {
      return /*#__PURE__*/React.createElement(AccountContentWrapper, {
        routes: routes,
        returnPath: returnPath
      }, /*#__PURE__*/React.createElement(OrderFeedback, {
        segments: segments,
        groups: groups,
        questions: questions,
        isLoading: isLoading,
        changeHandler: this.changeHandler,
        submitHandler: this.onValidate,
        isDisabled: isDisabled,
        errorsIds: errorsIds
      }));
    }
    if (isFeedbackCompleted) {
      return /*#__PURE__*/React.createElement(AccountContentWrapper, {
        isBackLinkShown: false,
        routes: routes,
        returnPath: returnPath
      }, /*#__PURE__*/React.createElement(FeedbackTyp, {
        isLoading: isFeedbackButtonLoading,
        submitHandler: this.redirectToRoot
      }));
    }
    return /*#__PURE__*/React.createElement(AccountContentWrapper, {
      isBackLinkShown: false,
      routes: routes,
      returnPath: returnPath
    }, /*#__PURE__*/React.createElement(OrderFeedback, {
      segments: segments,
      groups: groups,
      questions: questions,
      isLoading: isLoading,
      changeHandler: this.changeHandler,
      submitHandler: this.onValidate,
      isDisabled: isDisabled,
      errorsIds: errorsIds
    }));
  }
}
export default OrderFeedbackContainer;